module.exports = __webpack_public_path__ + "img/viewresume.3f88e5ca.gif";